import { REG_EXP_URL_PATTERN } from '../../../constants/regExp'
import i18n from '../../../i18n'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../Building'
import { FloatingTooltipContentText } from '../../Floating'
import {
  TableBuildingCell,
  TableCategoryListCell,
  TableDateCell,
  TableLinkCell,
  TablePhoneCell,
  TableTextCell,
  TableTitleCell,
  TableUserCell,
} from '../../Table'
import { toUserMultiValue } from '../../User'

import { ProviderTableCellName } from './ProviderTableRow.constants'

import ProviderIcon from '../../../icons/provider.svg'

function getBuildingLabel(option) {
  return option?.building?.title
}

function getCategoryLabel(option) {
  return option?.category?.name
}

function getBuildingApiParams(id, value) {
  return {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    contractor: id,
    exclude_id: value?.building?.id,
  }
}

function isValidUrl(url) {
  return REG_EXP_URL_PATTERN.test(url)
}

export function renderCell({ item, name, scrollRef, t, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case ProviderTableCellName.Name:
      return (
        <TableTitleCell
          {...restProps}
          tooltip
          additionalTooltipInfo={i18n.t('ProviderTable.ClickToOpenProviderKey')}
          avatarProps={{
            Icon: ProviderIcon,
            color: item.avatar_color,
            src: item.avatar,
            text: value,
          }}
          value={value}
        />
      )
    case ProviderTableCellName.Address:
    case ProviderTableCellName.Email:
    case ProviderTableCellName.OrderEmail:
      return <TableTextCell {...restProps} value={value} />

    case ProviderTableCellName.Website: {
      const isDisabled = !isValidUrl(value)

      return (
        <TableLinkCell
          {...restProps}
          disabled={isDisabled}
          text={value}
          tooltip={
            <FloatingTooltipContentText
              additionalText={t(
                isDisabled
                  ? 'ProviderTable.WebsiteLinkInactiveKey'
                  : 'ProviderTable.ClickOnWebsiteKey'
              )}
              text={value}
            />
          }
          value={value}
        />
      )
    }
    case ProviderTableCellName.ExternalId:
    case ProviderTableCellName.Description:
    case ProviderTableCellName.WorkingHours:
      return <TableTextCell {...restProps} value={value} />
    case ProviderTableCellName.Phone:
    case ProviderTableCellName.OrderPhone:
      return (
        <TablePhoneCell
          {...restProps}
          tooltip={
            <FloatingTooltipContentText
              additionalText={t('ProviderTable.ClickOnPhoneKey')}
              text={value}
            />
          }
          value={value}
        />
      )
    case ProviderTableCellName.Building:
      return (
        <TableBuildingCell
          {...restProps}
          getApiParams={getBuildingApiParams}
          getLabel={getBuildingLabel}
          id={item.id}
          scrollRef={scrollRef}
          value={value}
        />
      )
    case ProviderTableCellName.Created:
    case ProviderTableCellName.Updated:
      return <TableDateCell {...restProps} value={value} />
    case ProviderTableCellName.CreatedBy:
    case ProviderTableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )

    case ProviderTableCellName.Category: {
      const categoryApiParams = {
        contractor: item.id,
        exclude_id: item.categories?.category?.id,
      }

      return (
        <TableCategoryListCell
          {...restProps}
          apiParams={categoryApiParams}
          getLabel={getCategoryLabel}
          scrollRef={scrollRef}
          value={value}
        />
      )
    }
    default:
      return null
  }
}
